import type { ReactiveMap } from '@solid-primitives/map'
import { createEffect, onCleanup } from 'solid-js'
import {
  type Mesh,
  type Object3D
} from 'three'
import { type NeighborElevationCollection } from '../../../../rx/memo/useNodeNeighborBaseFloorElevationReactiveMap'
import type { Nullable } from '../../../../typescript'
import { EntityTypeId } from '../../../core/entity/EntityTypeId.enum'
import type { Entity } from '../../../core/entity/index'
import createEntityRngConfig from '../../../core/rng/createEntityRngConfig'
import { next } from '../../../core/rng/index'
import { default as addRandomTileDetailPropPosition } from '../../fn/addRandomTileDetailPropPosition'
import disposeRecursive from '../../fn/disposeRecursive'
import enableShadows from '../../fn/enableShadows'
import createEntityQuaterniusCactusMesh from '../DetailProps/createEntityQuaterniusCactusMesh'

// const grassCountPool = [0, 1, 2, 2, 3, 3, 4, 5]
// const scrubCountPool = [0, 0, 1, 1, 2]

export default function createTerrainMesh1DetailPropsEffect(
  neighborBaseElevationReactiveMap: ReactiveMap<number, NeighborElevationCollection>,
  nodeIndex: number,
  parentObj: Object3D,
  getEntity: () => Nullable<Entity>
): void {
  // const terrainMesh1ReactiveMap = useTerrainMesh1ReactiveMap(engine)
  // console.log('createTerrainMesh1DetailPropsEffect.init')
  const items: Nullable<Array<Object3D>> = []
  createEffect(() => {
    const baseElevationsCollection = neighborBaseElevationReactiveMap.get(nodeIndex)
    if (!baseElevationsCollection) {
      return
    }
    // const { zAt } = result
    const ent0 = getEntity()
    // console.log('createTerrainMesh1DetailPropsEffect.effect', ent0 ? entityDisplayName(ent0) : null, { entityId: ent0?.id })
    cleanup()
    if (ent0) {
      const { id: entityId, etype_id } = ent0
      // let count: number
      // console.log('createTerrainMesh1DetailPropsEffect.effect', { entityId })
      // const rng = tmpRngWith(entityId)
      const rng = createEntityRngConfig(entityId)

      if (etype_id === EntityTypeId.Plain) {
        // TODO small bush (small tree)?
        // grassland
        // TODO Tall grass
        // TODO Wildflowers
        // TODO Grassy mounds
        // TODO Tufts of different grass species
        // TODO walking stick
        // plains
        // TODO cracks/streaks of dirt?
        // TODO Ant mounds or burrows – small terrain bulges with dark centers.
        // TODO pebbles
      } else if (etype_id === EntityTypeId.Snow) {
        // TODO Thin ice cracks
        // TODO snow pile (aka drift)
        // TODO snow bush (small tree)?
        // TODO Abandoned campfire ring
        // TODO Small dead branches or twigs?
        // TODO tree stomps
        // TODO Fallen dead trees – cracked and weathered wood.

        // I'm not going to implement "snow trees" because
        //  I don't want players to be confused about forest tiles
      } else if (etype_id === EntityTypeId.Desert) {
        if (next(rng) < 0.4) {
          createEntityQuaterniusCactusMesh(rng).then((item: Object3D) => {
            addRandomTileDetailPropPosition(parentObj, item as Mesh, items, rng, baseElevationsCollection)
            const propZ = item.userData.z
            if (isFinite(propZ)) {
              // item.position.z += propZ
            }
            // item.position.z += 0.9
            // item.position.z += (item as Mesh).geometry.boundingSphere?.radius ?? 0
            enableShadows(item)
          })
        }
        // TODO Blooming cactus flowers?
        // TODO cracked earth
        // TODO Skeleton fragments
        // TODO Tumbleweeds?
        // TODO Small dead branches or twigs?
        // TODO pebbles
        // I'm not going to implement "desert tree" because
        // cactuses are iconic and I don't want players to be confused
        // about forest tiles
      } else if (etype_id === EntityTypeId.Sea) {
        // TODO
      } else if (etype_id === EntityTypeId.Forest) {
        // TODO Ferns – broad-leafed ground plants for shady coverage.
        // TODO Low shrubs or brambles – with or without berries.
        // TODO Tiny mushrooms – in clusters, stumps, or shady ground.
        // TODO Vines on trees
        // Dead leaves – scattered on the ground for texture variety.
        // Exposed roots – twisted shapes hugging rocks or soil.
        // Nests – in trees or shrubs (bird or squirrel).
        // Mud patches – from water pooling or animal paths.
        // TODO Fallen dead trees – cracked and weathered wood.
      } else if (etype_id === EntityTypeId.Mountain) {
        // TODO small bush (small tree)?
        // TODO Cave mouths
      } else if (etype_id === EntityTypeId.Shoal) {
        // note that some of these concepts might make no sense near desert/snow
        // TODO Rippled sand textures – shallow wave-like patterns from tides.
        // TODO Tide pools – tiny, reflective water depressions with possible micro-life hints.
        // TODO Seashell clusters – single or grouped shells of varying size.
        // TODO Beached driftwood – wet or dry wood chunks, semi-buried in sand.
        // TODO Seaweed clumps – darker green/brown low blobs, often along waterlines.
        // TODO Smooth pebbles or small stones – partially embedded, water-worn.
        // TODO Dried coral fragments – pale, porous, slightly spiky shapes.
        // TODO Foam edge sprites – animated white noise near the waterline.
        // TODO Crab burrows / tracks – small holes or dotted trails.
        // TODO starfish – small, round, with a few spines.
        // TODO Feather debris – as birds often rest or feed on shoals.
        // TODO Bird footprints – simple repeating Y-tracks in the wet sand.
        // TODO Boat fragment – a subtle sliver of hull or rotting wood slat.
        // TODO Waterlogged reeds – standing near pools or just above the tide line.

        // might make more sense to have a traveling animation for these
        // outside of the tile's mesh context
        // TODO Tiny jumping fish or splashes – randomized sprite animations.
        // Translucent jelly blobs – hinting at jellyfish.
      }

      items.map(enableShadows)
    }

    onCleanup(cleanup)
  })

  function cleanup() {
    if (items) {
      items.forEach(disposeRecursive)
      items.length = 0
    }
  }

  onCleanup(cleanup)
}


